exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "h2 {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-align: center;\n      align-items: center; }\n  h2 .load {\n    margin-left: 24px;\n    width: 24px;\n    height: 24px; }\n\nbutton {\n  margin: 0; }\n\ninput {\n  width: 100%;\n  text-align: center; }\n\n.spinner {\n  margin-top: 2px;\n  margin-bottom: 2px; }\n\n.new {\n  background: #007cbb;\n  color: #fff;\n  display: inline-block;\n  padding-left: 6px;\n  padding-right: 6px;\n  border-radius: 3px; }\n\nselect {\n  height: 28px; }\n\np {\n  text-align: center;\n  margin: 0;\n  font-size: 14px; }\n\n.sys {\n  padding-top: 12px; }\n  .sys button {\n    background: #49afd9;\n    color: #000 !important; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /opt/build/repo/src/app/views/site-admin/site-setup/shared/site-setup.scss
// module id = ../../../../../src/app/views/site-admin/site-setup/shared/site-setup.scss
// module chunks = main